<template>
  <div v-if="available">
    <ButtonView type="soft" color="success" size="small" @click.prevent="active = true">
      <i class="fas fa-file-shield"></i>
    </ButtonView>
    <ModalView v-model:active="active">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="mb-0">{{ translate("permissions") }}</h3>
          <ModalCloseButtonView @click="active = false"/>
        </div>
      </template>
      <template v-slot:body>
        <HttpContentView :endpoint="utilities.path('resources/@/@/permissions', type, id)" v-model:reload="reload" @response="permissions = $event.permissions">
          <template v-slot:content="{ data }">
            <div class="d-flex flex-column g-3">
              <div v-for="role in data.roles" :key="role.id">
                <div class="d-flex align-items-center g-2 mb-3">
                  <i class="fas fa-tag" :style="{ color: role.color }"></i>
                  <span>{{ role.name }}</span>
                </div>
                <div class="list-group">
                  <HttpFormView :endpoint="utilities.path('roles/@/resources/@/@/permissions/@', role.id, type, id, permission.key)" v-for="permission in permissions" :key="permission.key" method="put" @success="reload = true">
                    <template v-slot:form="{ content, submit, loading }">
                      <div class="list-group-item list-group-item-action" :class="{ disabled: !canModifyPermission(role, permission) }" @click="content.active = !role.permissions.includes(permission.key); submit()">
                        <div class="d-flex align-items-center g-2">
                          <CheckboxView color="primary" :title="permission.name" :active="role.permissions.includes(permission.key)"/>
                        </div>
                        <div v-if="permission.dependencies && permission.dependencies.length > 0" class="small mt-2">
                          <span class="fw-bold">{{ translate("requires") }}:</span>
                          {{ permission.dependencies.map(dependency => getPermission(dependency)?.name).join(", ") }}
                        </div>
                        <div v-if="permission.dependents && permission.dependents.length > 0" class="small mt-2">
                          <span class="fw-bold">{{ translate("required_by") }}:</span>
                          {{ permission.dependents.map(dependent => getPermission(dependent)?.name).join(", ") }}
                        </div>
                        <SpinnerView color="primary" :active="loading"/>
                      </div>
                    </template>
                  </HttpFormView>
                </div>
              </div>
              <div v-if="data.roles.length === 0">
                {{ translate("community.no.roles") }}
              </div>
            </div>
          </template>
        </HttpContentView>
      </template>
    </ModalView>
  </div>
</template>

<script>
import {ButtonView, HttpContentView, ModalView, HttpFormView, utilities, CheckboxView, ModalCloseButtonView, SpinnerView} from "@/niftybit";
import authorization from "@/authorization";

export default {
  name: "ResourcePermissionModalView",
  components: {SpinnerView, HttpFormView, ButtonView, HttpContentView, ModalView, CheckboxView, ModalCloseButtonView},
  props: {
    type: String,
    id: String
  },
  data() {
    return {
      active: false,
      reload: false,
      permissions: []
    }
  },
  computed: {
    utilities() {
      return utilities
    },
    available() {
      return authorization.permission("roles.edit");
    }
  },
  methods: {
    getPermission(permission) {
      return this.permissions.find(item => item.key === permission.key);
    },
    canModifyPermission(role, permission) {
      if (role.permissions.includes(permission.key)) {
        if (permission.dependents && permission.dependents.some(dependent => role.permissions.includes(dependent.key))) return false;
      } else {
        if (permission.dependencies && permission.dependencies.some(dependency => !role.permissions.includes(dependency.key))) return false;
      }
      return true;
    }
  }
}
</script>